import CookieBar from "./index";

window.nicWidgets = window.nicWidgets || {};
window.nicWidgets.cookieBar = CookieBar;
